'use client';

import type { VariantProps } from 'class-variance-authority';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  type dialogPopupVariants,
} from './dialog';

type SimpleDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: React.ReactNode;
  size?: VariantProps<typeof dialogPopupVariants>['size'];
  hideClose?: boolean;
  isDismissible?: boolean;
  footer?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
};

function SimpleDialog({
  open,
  onOpenChange,
  title,
  description,
  size,
  hideClose,
  isDismissible = true,
  footer,
  className,
  children,
}: SimpleDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen && !isDismissible) return;
        onOpenChange(nextOpen);
      }}
      disablePointerDismissal={!isDismissible}
    >
      <DialogContent size={size} hideClose={hideClose || !isDismissible} className={className}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {children}
        {footer && <DialogFooter>{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  );
}

export type { SimpleDialogProps };
export { SimpleDialog };
